/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroups,
    GetOutletByGroupID,
    GetViewOutletOrdersDetails,
    ApproveReadyToWeighment
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetOutletByGroupID(groupID) {
    const response = await CommonGet('/api/CustomerOrdersOutletWise/GetOutletByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetViewOutletOrdersDetails(factoryID, date) {
    const response = await CommonGet('/api/ViewOutletOrders/GetViewOutletOrdersDetails', 'factoryID=' + parseInt(factoryID) + '&date=' + date);
    return response.data;
}

async function ApproveReadyToWeighment(data, date) {
    var values = {
        factoryID: parseInt(data),
        date: date,
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonGet('/api/ViewOutletOrders/ApproveReadyToWeighment', 'factoryID=' + parseInt(values.factoryID) + '&modifiedBy=' + parseInt(values.modifiedBy) + '&date=' + (values.date));
    return response;
}